<template>
  <v-navigation-drawer
      v-model="drawer"
      app
    >
    <v-list dense>
      <v-list-item link to="/">
        <v-list-item-action>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Рабочий стол</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/customers" v-if="!isEditor">
        <v-list-item-action>
          <v-icon>mdi-card-account-phone</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Клиенты</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/users" v-if="isAdmin">
        <v-list-item-action>
          <v-icon>mdi-account-box-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Пользователи</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/sites">
        <v-list-item-action>
          <v-icon>mdi-web</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Сайты</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/prices" v-if="isAdmin || isEditor || isPartner">
        <v-list-item-action>
          <v-icon>mdi-calculator</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Прайс-лист</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/constructor" v-if="isAdmin || isEditor">
        <v-list-item-action>
          <v-icon>mdi-axis-arrow</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Конструктор</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/estimates" v-if="isAdmin || isEditor || isPartner">
        <v-list-item-action>
          <v-icon>mdi-view-list</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Сметы</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/buildings" v-if="isAdmin">
        <v-list-item-action>
          <v-icon>mdi-home-city</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>База новостроек</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/specialists" v-if="isAdmin || isPartner">
        <v-list-item-action>
          <v-icon>mdi-account-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>База мастеров</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/actual" v-if="isAdmin || isEditor">
        <v-list-item-action>
          <v-icon>mdi-checkbox-marked</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Актуальность данных</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'main-menu',
  
  props: {
    value: Boolean
  },

  data() {
    return {
      drawer: this.value
    }
  },

  watch: {
    value(val, oldVal) {
      this.drawer = val;
    },

    drawer(val, oldVal) {
      this.$emit('input', val);
    }
  },

  computed: {
    ...mapState('users', ['localUser']),
    ...mapGetters('users', ['isAdmin', 'isEditor', 'isPartner'])
  }
}
</script>